import { useEffect } from 'react';
import { DefaultValues, SubmitHandler } from 'react-hook-form';
import { FormContainer, useForm } from 'react-hook-form-mui';

import Box from '@mui/material/Box';
import { ILoanListGroupFilterResponse } from '@patient-fi/fed-types';

import { BaseFiltersButtons, FiltersContainer, GroupFilterItem } from '../index';

interface FiltersEngineProps {
  onSubmit: SubmitHandler<Record<string, unknown>>;
  expanded?: boolean;
  filters: ILoanListGroupFilterResponse[];
  defaultValues?: DefaultValues<Record<string, unknown>>;
  defaultFiltersSearchValues?: DefaultValues<Record<string, unknown>>;
}

function FiltersEngine({ onSubmit, filters, expanded = true, defaultValues, defaultFiltersSearchValues }: FiltersEngineProps) {
  const formContext = useForm<Record<string, unknown>>({
    defaultValues,
  });

  useEffect(() => {
    if (defaultFiltersSearchValues) {
      formContext.reset(defaultFiltersSearchValues);
    }
  }, [defaultFiltersSearchValues, formContext]);

  const onResetClick = () => {
    formContext.reset(defaultValues);
  };

  return (
    <FiltersContainer expanded={expanded}>
      <FormContainer<Record<string, unknown>> formContext={formContext} onSuccess={onSubmit}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            columnGap: '1.5rem',
            rowGap: '1.5rem',
            pt: 2.5,
          }}
        >
          {filters.map((filter) => (
            <GroupFilterItem key={filter._id} filter={filter} />
          ))}
        </Box>
        <BaseFiltersButtons onResetClick={onResetClick} />
      </FormContainer>
    </FiltersContainer>
  );
}

export default FiltersEngine;
